import React from 'react';

const MainContainer = ({ children }) => {
  return (
    <div className="mx-auto main-container">
      {children}
    </div>
  );
};

export default MainContainer;
